import React, { useRef } from "react";
import { Helmet } from "react-helmet-async";
import "./CustomSoftwareSolutions.css";


// Hero Image
import SoftwareHeroImg from "../assets/custom-software-hero.jpeg";


const CustomSoftwareSolutions = () => {

  const csServicesRef = useRef(null);


const scrollCsServices = (direction) => {

  if (csServicesRef.current) {

    csServicesRef.current.scrollBy({

      left: direction === "next" ? 320 : -320,

      behavior:"smooth"

    });

  }

};
  


const whySoftwareRef = useRef(null);


const scrollWhySoftware = (direction) => {

  if (whySoftwareRef.current) {

    whySoftwareRef.current.scrollBy({

      left: direction === "next" ? 320 : -320,

      behavior:"smooth"

    });

  }

};



  const handleCTAClick = () => {
    if (window.gtag) {
      window.gtag("event", "click", {
        event_category: "CTA",
        event_label: "WhatsApp Software CTA",
        value: 1,
      });
    }
  };

  
  return (
    <>
      {/* SEO */}
      <Helmet>

        <link rel="canonical" href="https://satimatechnova.co.ke/custom-software-solutions/" />


        <title>Custom Software Solutions in Kenya | Satima Technova Solutions</title>
        <meta
          name="description"
          content="Build tailored software solutions for your business in Kenya. Satima Technova Solutions delivers custom web, mobile, and desktop applications to streamline operations, increase efficiency, and support growth."
        />
        <meta
          name="keywords"
          content="custom software Kenya, web applications Kenya, mobile apps Kenya, desktop software Kenya, software development Kenya, Satima Technova Solutions"
        />
        <meta name="author" content="Satima Technova" />

        {/* Open Graph */}
        <meta property="og:title" content="Custom Software Solutions in Kenya" />
        <meta
          property="og:description"
          content="Get expert custom software development for web, mobile, and desktop applications tailored to your business needs in Kenya."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://satimatechnova.co.ke/custom-software-solutions/" />


        <script type="application/ld+json">
{`
{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How much does custom software development cost?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "The cost of custom software development depends on the complexity, features, design requirements, integrations, and overall project scope. Satima Technova Solutions provides tailored quotations after understanding your business needs."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to develop custom software?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Development timelines depend on the size and complexity of the project. Simple applications may take a few weeks, while larger systems require more time for planning, development, testing, and deployment."
      }
    },
    {
      "@type": "Question",
      "name": "What types of software can you build?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Satima Technova Solutions develops custom web applications, mobile applications, business automation systems, management software, database solutions, and other software solutions designed around your business processes."
      }
    },
    {
      "@type": "Question",
      "name": "Do you develop mobile applications?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We develop user-friendly Android and iOS mobile applications that help businesses improve customer experience and streamline operations."
      }
    },
    {
      "@type": "Question",
      "name": "Can you integrate software with existing systems?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We integrate custom software with existing tools, APIs, databases, payment systems, and other business platforms to ensure smooth operations."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide software maintenance and support?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Satima Technova Solutions provides software maintenance, updates, troubleshooting, and technical support to ensure your software remains secure, reliable, and performs efficiently."
      }
    },
    {
      "@type": "Question",
      "name": "How do I start my software development project?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Simply contact Satima Technova Solutions for a consultation. We will understand your requirements, discuss your goals, recommend the right solution, and guide you through the software development process."
      }
    }
  ]
}
`}
</script>



      </Helmet>

      <main className="cs-page">

        {/* TRUST SCROLLING BAR */}

<section className="cs-trust-scroll">

  <div className="cs-trust-track">


    <div className="cs-trust-content">

      <span>✓ Custom Software Development</span>

      <span>✓ Business Automation</span>

      <span>✓ Scalable Solutions</span>

      <span>✓ Secure Systems</span>

    </div>



    <div className="cs-trust-content">

      <span>✓ Custom Software Development</span>

      <span>✓ Business Automation</span>

      <span>✓ Scalable Solutions</span>

      <span>✓ Secure Systems</span>

    </div>


  </div>

</section>



{/* HERO SECTION */}

<section
  className="cs-hero-section"
  style={{
    backgroundImage: `url(${SoftwareHeroImg})`
  }}
>
  <div className="cs-hero-overlay">

    <div className="cs-hero-wrapper">

      <div className="cs-hero-text">

        {/* SEO HEADER - HIDDEN */}

        <h1 className="cs-hidden-heading">
          Custom Software Solutions in Kenya That Streamline Your Business
        </h1>

        <div className="cs-intro-content">

          <span className="cs-hero-tag">
            CUSTOM SOFTWARE SOLUTIONS
          </span>

          <h2>
            Software Built Around
            <br />
            <span>Your Business.</span>
          </h2>

          <p className="cs-intro-line">
            Custom digital systems designed to automate processes,
            improve efficiency, and help your business operate smarter.
          </p>

        </div>

        <a
          href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I%E2%80%99m%20interested%20in%20custom%20software%20solutions."
          target="_blank"
          rel="noopener noreferrer"
          className="cs-hero-cta"
          onClick={handleCTAClick}
        >
          Start Your Project
        </a>

        <div className="cs-trust-points">

          <p>
            ✓ Business-focused solutions
          </p>

          <p>
            ✓ Scalable systems
          </p>

          <p>
            ✓ Built around your workflow
          </p>

        </div>

      </div>

    </div>

  </div>
</section>

{/* =====================================
    SERVICES SECTION
===================================== */}

<section className="cs-services-section">


  <div className="cs-services-container">



    <div className="cs-services-heading">


      <span className="cs-section-tag">
        OUR SERVICES
      </span>


      <h2>
        Custom Software Development Services in Kenya
      </h2>


      <p>
        We build reliable software solutions designed around your business
        processes, helping you automate operations, improve efficiency,
        and support long-term growth.
      </p>


    </div>





    <div 
      className="cs-services-grid"
      ref={csServicesRef}
    >



      {/* SERVICE 1 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-laptop-code"></i>

        </div>


        <h3>
          Custom Web Applications
        </h3>


        <p>
          Build powerful web applications designed around your business
          processes to improve efficiency and productivity.
        </p>


      </div>





      {/* SERVICE 2 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-mobile-alt"></i>

        </div>


        <h3>
          Mobile Application Development
        </h3>


        <p>
          Develop user-friendly Android and iOS applications that help your
          business connect with customers anywhere.
        </p>


      </div>





      {/* SERVICE 3 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-cogs"></i>

        </div>


        <h3>
          Business Process Automation
        </h3>


        <p>
          Automate repetitive tasks and workflows to reduce manual work and
          improve operational efficiency.
        </p>


      </div>





      {/* SERVICE 4 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-network-wired"></i>

        </div>


        <h3>
          System Integration
        </h3>


        <p>
          Connect your software with existing systems, APIs, and databases
          for seamless business operations.
        </p>


      </div>





      {/* SERVICE 5 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-expand-arrows-alt"></i>

        </div>


        <h3>
          Scalable Software Solutions
        </h3>


        <p>
          Build secure software solutions that can grow alongside your
          business and changing requirements.
        </p>


      </div>





      {/* SERVICE 6 */}

      <div className="cs-service-card">


        <div className="cs-service-icon">

          <i className="fas fa-tools"></i>

        </div>


        <h3>
          Software Maintenance & Support
        </h3>


        <p>
          Keep your software secure, updated, and performing efficiently
          with continuous support and monitoring.
        </p>


      </div>



    </div>





    {/* MOBILE CAROUSEL ARROWS */}

    <div className="cs-services-arrows">


      <button
        aria-label="Previous service"
        onClick={() => scrollCsServices("prev")}
      >

        ‹

      </button>




      <button
        aria-label="Next service"
        onClick={() => scrollCsServices("next")}
      >

        ›

      </button>


    </div>



  </div>


</section>
      

{/* =====================================
    WHY CHOOSE SATIMA
===================================== */}


<section className="why-satima-section">


  <div className="why-satima-header">


    <h2>
      Why Choose Satima for Custom Software Development?
    </h2>


    <p>
      We create reliable software solutions designed around your business
      needs, helping you improve efficiency, solve challenges, and build
      technology that supports long-term growth.
    </p>


  </div>





  <div 
    className="why-satima-grid"
    ref={whySoftwareRef}
  >




    {/* CARD 1 */}

    <div className="why-card">


      <div className="why-icon">

        <i className="fas fa-code"></i>

      </div>


      <h3>
        Tailored Software Solutions
      </h3>


      <p>
        We develop software based on your unique business requirements
        instead of forcing your processes into generic systems.
      </p>


    </div>






    {/* CARD 2 */}

    <div className="why-card">


      <div className="why-icon">

        <i className="fas fa-business-time"></i>

      </div>


      <h3>
        Business-Focused Approach
      </h3>


      <p>
        We focus on creating technology that improves efficiency, solves
        challenges, and supports your growth objectives.
      </p>


    </div>






    {/* CARD 3 */}

    <div className="why-card">


      <div className="why-icon">

        <i className="fas fa-shield-alt"></i>

      </div>


      <h3>
        Scalable & Secure Development
      </h3>


      <p>
        Our solutions are built with future growth, security, and performance
        in mind to support your evolving business needs.
      </p>


    </div>






    {/* CARD 4 */}

    <div className="why-card">


      <div className="why-icon">

        <i className="fas fa-headset"></i>

      </div>


      <h3>
        Continuous Technical Support
      </h3>


      <p>
        We provide guidance and support to ensure your software continues
        delivering value as your business grows.
      </p>


    </div>





  </div>






  {/* MOBILE ARROWS */}

  <div className="why-satima-arrows">


    <button
      aria-label="Previous card"
      onClick={() => scrollWhySoftware("prev")}
    >

      ‹

    </button>




    <button
      aria-label="Next card"
      onClick={() => scrollWhySoftware("next")}
    >

      ›

    </button>


  </div>



</section>

      

<section className="faq-section">


  <div className="faq-header">


    <h2>
      Frequently Asked Questions
    </h2>


    <p>
      Find answers to common questions about our custom software development
      services for businesses in Kenya.
    </p>


  </div>




  <div className="faq-container">



    <details className="faq-item" open>


      <summary>
        How much does custom software development cost?
      </summary>


      <p>
        The cost of custom software development depends on the complexity,
        features, design requirements, integrations, and overall project scope.
        We provide a tailored quotation after understanding your business needs.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How long does it take to develop custom software?
      </summary>


      <p>
        Development timelines depend on the size and complexity of the project.
        Simple applications may take a few weeks, while larger systems require
        more time for planning, development, testing, and deployment.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        What types of software can you build?
      </summary>


      <p>
        We develop custom web applications, mobile applications, business
        automation systems, management software, database solutions,
        and other software solutions designed around your business processes.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Do you develop mobile applications?
      </summary>


      <p>
        Yes. We develop user-friendly mobile applications for Android and iOS
        platforms that help businesses improve customer experience and
        streamline operations.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Can you integrate software with existing systems?
      </summary>


      <p>
        Yes. We can integrate your custom software with existing tools,
        APIs, databases, payment systems, and other business platforms
        to ensure smooth operations.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        Do you provide software maintenance and support?
      </summary>


      <p>
        Yes. We provide ongoing maintenance, updates, troubleshooting, and
        technical support to ensure your software remains secure, reliable,
        and performs efficiently.
      </p>


    </details>





    <details className="faq-item">


      <summary>
        How do I start my software development project?
      </summary>


      <p>
        Simply contact Satima Technova Solutions for a consultation. We will
        understand your requirements, discuss your goals, recommend the right
        solution, and guide you through the development process.
      </p>


    </details>



  </div>


</section>

    

<section className="final-cta-section">


  <div className="final-cta-content">



    <span className="final-cta-label">
      BUILD YOUR DIGITAL SOLUTION
    </span>




    <h2>
      Ready To Build Software
      <br />
      That Transforms Your Business?
    </h2>




    <p>
      Whether you need a web application, mobile app, automation system, or
      custom business software, Satima Technova Solutions builds reliable
      technology solutions designed around your goals.
    </p>





    <div className="final-cta-benefits">


      <span>
        Custom Development
      </span>


      <span>
        Business Automation
      </span>


      <span>
        Scalable Solutions
      </span>


      <span>
        Technical Support
      </span>


    </div>





    <a
      href="https://wa.me/254775137928?text=Hi%20Satima%20Technova,%20I'm%20interested%20in%20custom%20software%20development."
      target="_blank"
      rel="noopener noreferrer"
      className="final-cta-btn"
      onClick={handleCTAClick}
    >
      Start Your Software Project
    </a>





    <p className="final-cta-note">
      Custom solutions • Reliable technology • Supporting businesses across Kenya
    </p>



  </div>


</section>



      </main>
    </>
  );
};

export default CustomSoftwareSolutions;